import { isNil } from 'lodash';

import { ChartDisplayElementModel, ChartValidSourceStateEnum } from './chart-display-element.model';
import { ChartMetricsEnum } from '../enums/chart-metrics.enum';
import { CoverageMetricChartDisplaySettings } from '../../../Common/Charts/models/coverage-metric-chart-display-settings.model';
import { CoverageMetricChartStyles } from '../../../Common/Charts/models/coverage-metric-chart-styles.model';
import { ReportSeriesModel } from './report-series.model';
import { ChartIconEnum } from '../enums/chart-icon.enum';
import { ReportBlockTypeEnum } from '../enums/report-block-type.enum';


export class CoverageMetricChartDisplayElement extends ChartDisplayElementModel {

    override chartHeaderSettings: CoverageMetricChartDisplaySettings;
    override styles: CoverageMetricChartStyles;

    titleIcon: ChartMetricsEnum | ChartIconEnum;
    customCurrentValue: number;

    constructor(
        title: string,
        series: ReportSeriesModel[],
        styles: CoverageMetricChartStyles,
        titleIcon: ChartMetricsEnum | ChartIconEnum,
        customCurrentValue: number
    ) {
        super(title, series, styles);
        this.styles = styles || new CoverageMetricChartStyles();
        this.chartHeaderSettings = this.styles.chartDisplaySettings;
        this.titleIcon = titleIcon;
        this.customCurrentValue = customCurrentValue;
        this.dynamicTitle = true;
    }

    clone(): CoverageMetricChartDisplayElement {
        const displayElement = new CoverageMetricChartDisplayElement(
            this.title,
            this.series.map(x => x.clone()),
            this.styles,
            this.titleIcon,
            this.customCurrentValue
        );
        displayElement.chartHeaderSettings = this.chartHeaderSettings.clone();
        displayElement.chartSpecificType = this.chartSpecificType;
        displayElement.metric = this.metric;
        displayElement.displayType = this.displayType;
        displayElement.size = this.size;
        displayElement.dateRangeLabel = this.dateRangeLabel;
        displayElement.referralTypes = this.referralTypes;
        displayElement.prevents = this.prevents;
        displayElement.sentiments = this.sentiments;
        displayElement.labelDisplayOptions = this.labelDisplayOptions;
        displayElement.stackedChartTypes = this.stackedChartTypes;
        displayElement.networkSelection = this.networkSelection;
        displayElement.metrics = this.metrics?.slice();
        displayElement.seriesCount = this.seriesCount;
        displayElement.numOfItems = this.numOfItems;
        displayElement.dynamicTitle = this.dynamicTitle;
        displayElement.contentFilters = this.contentFilters.clone();
        displayElement.termType = this.termType;
        displayElement.mapChartColorScheme = this.mapChartColorScheme;
        displayElement.mapChartChoroplethInterpolationType = this.mapChartChoroplethInterpolationType;
        displayElement.dateRange = this.dateRange;
        displayElement.timeInterval = this.timeInterval;
        displayElement.topMentionsSortField = this.topMentionsSortField;
        displayElement.topMentionsMetadata = this.topMentionsMetadata;
        displayElement.topCuratedMentions = this.topCuratedMentions;
        displayElement.trackedColorChanged = this.trackedColorChanged;
        displayElement.legendPosition = this.legendPosition;
        displayElement.displayAnnotationInExport = this.displayAnnotationInExport;
        displayElement.chartAnnotations = this.chartAnnotations?.clone();
        return displayElement;
    }

    checkValidSourcesForChartType(chartType: ReportBlockTypeEnum): ChartValidSourceStateEnum {
        if (this.metric === ChartMetricsEnum.custom && !isNil(this.customCurrentValue)) {
            return ChartValidSourceStateEnum.ALL;
        }
        return super.checkValidSourcesForChartType(chartType);
    }

    areAllSourcesValidForChartType(chartType: ReportBlockTypeEnum): boolean {
        if (this.metric === ChartMetricsEnum.custom && !isNil(this.customCurrentValue)) {
            return true;
        }
        return super.areAllSourcesValidForChartType(chartType);
    }
    override isEqual(other: CoverageMetricChartDisplayElement): boolean {
        if (!super.isEqual(other)) {
            return false;
        }
        if (this.title !== other.title) {
            return false;
        }

        if (this.titleIcon !== other.titleIcon) {
            return false;
        }
        if (this.customCurrentValue !== other.customCurrentValue) {
            return false;
        }
        return true;
    }
}
